import React, { useState, useEffect } from 'react'
import { DateTime } from 'luxon'
import { PendingTransactionsIcon } from '@util/svgicon';
import { frodoPointActivities } from '@services/api';

const FrodobotsPointHistory = () => {
    const [frodobotsPointHistoryData, setFrodobotsPointHistoryData] = useState([]);

    useEffect(() => {
        fetchFrodobotsPointHistory();
    }, []);

    const fetchFrodobotsPointHistory = async () => {
        const resp = await frodoPointActivities();
        if (resp?.frodo_point_activities?.length > 0) {
            setFrodobotsPointHistoryData(resp.frodo_point_activities);
        }
    }

    return (
        <div className="w-full h-full flex flex-col gap-[18px]">
            <div className='w-full flex pt-0 pr-[8px] pb-[8px] pl-0 justify-between items-center'>
                <div className='flex items-center gap-[16px]'>
                    <div className='flex items-center gap-[8px]'>
                        <PendingTransactionsIcon />
                        <p className='text-[#282828] text-[18px] not-italic font-medium leading-[28px] tracking-[-0.72px]'>Frodobots Points History</p>
                    </div>
                </div>
            </div>
            <table className='w-full flex flex-col py-[8px] justify-between items-center gap-[6px]'>
                <thead className='w-full flex py-[8px] justify-between items-center rounded-[8px] bg-[#FAFAFA]'>
                    <tr className='w-full flex py-[8px] justify-between rounded-[8px]'>
                        <th className='w-[33.33%] text-[#727272] text-center text-[13px] not-italic font-medium leading-[15px] tracking-[-0.52px]'>Points</th>
                        <th className='w-[33.33%] text-[#727272] text-center text-[13px] not-italic font-medium leading-[15px] tracking-[-0.52px]'>Activity Type</th>
                        <th className='w-[33.33%] text-[#727272] text-center text-[13px] not-italic font-medium leading-[15px] tracking-[-0.52px]'>Date</th>
                    </tr>
                </thead>
                <tbody className='w-full flex flex-col py-[8px] items-center gap-[24px] rounded-[8px] bg-[#FAFAFA]'>
                    {frodobotsPointHistoryData.length > 0 ? (
                        frodobotsPointHistoryData.map((frodobotsPointHistory) => (
                            <tr key={frodobotsPointHistory.id} className='w-full flex justify-between items-center'>
                                <td className='w-[33.33%] text-[#727272] text-center text-[13px] sm:text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px]'>{frodobotsPointHistory.points}</td>
                                <td className='w-[33.33%] text-[#727272] text-center text-[13px] sm:text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px]'>{frodobotsPointHistory.activity_type || '-'}</td>
                                <td className='w-[33.33%] text-[#727272] text-center text-[13px] sm:text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px]'>
                                    {DateTime.fromISO(frodobotsPointHistory.created_at).toFormat('MMMM dd, yyyy, hh:mm a')}
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr className='w-full flex justify-center items-center'>
                            <td colSpan="9" className="text-[#727272] text-center text-[13px] sm:text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px]">No frodobots point history found</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    )
}

export default FrodobotsPointHistory
